<script lang="ts">
  import type {Collection, User} from '../types'
  import {replaceValues, t} from '../i18n'
  import LoadMore from '../shared/LoadMore.svelte'
  import ModalTemplate from '../shared/ModalTemplate.svelte'

  export let collection: Collection

  let users: User[] = []
  let followersUrl = `/collections/${collection.id}/followers`
</script>

<ModalTemplate size="small" scrolling>
  <div class="modal-content">
    <h2 class="tc">{collection.name}</h2>
    <div class="followers-count tc">
      {replaceValues(t.collection.followers_count, {n: collection.followers_count})}
    </div>

    <div class="grid four tc">
      {#each users as user}
        {#if user}
          <div class="grid__item">
            <div class="follower__photo">
              <a href={user.link}>
                <img src={user.avatar_big_thumgb} alt={user.full_name}/>
              </a>
            </div>
            <div class="follower__name">
              <a href={user.link}>{user.full_name}</a>
            </div>
          </div>
        {/if}
      {/each}
    </div>

    <LoadMore url={followersUrl} bind:items={users}/>
  </div>
</ModalTemplate>


